import React from "react";

import CSSModules from "lib/utils/css-modules";
import styles from "./TotalStockLeftField.less";
import * as FormControl from "lib/components/FormControl";

const totalStockLeftTypes = {
  unavailable: "unavailable",
  specified: "specified",
};
const totalStockLeftTypeOptions = Object.values(totalStockLeftTypes).map((totalStockLeftType) => [
  totalStockLeftType,
  I18n.t(`papp.accommodation.Accommodation.totalStockLeftTypes.${totalStockLeftType}`),
]);

@CSSModules(styles)
export default class TotalStockLeftField extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      totalStockLeftType: null,
    };
  }

  handleTotalStockLeftTypeChange(nextTotalStockLeftType) {
    const { onChange } = this.props;
    this.setState({ totalStockLeftType: nextTotalStockLeftType }, () => {
      if (nextTotalStockLeftType === totalStockLeftTypes.unavailable) {
        return onChange(0);
      } else if (nextTotalStockLeftType === totalStockLeftTypes.specified) {
        return onChange(1);
      }
      onChange(null);
    });
  }

  render() {
    const { value, onChange, loading } = this.props;
    const { totalStockLeftType } = this.state;

    return (
      <div styleName="total-stock-left-field">
        <FormControl.SelectFormGroup
          value={totalStockLeftType}
          onChange={this.handleTotalStockLeftTypeChange.bind(this)}
          label={I18n.t("papp.accommodation.AccommodationSchedulerView.totalStockLimit")}
          options={totalStockLeftTypeOptions}
          className="u-largeWidth availability-type"
          placeholder={I18n.t(`papp.accommodation.Accommodation.totalStockLeftTypes.noChanges`)}
          includeBlank
          inlineLabel
          disabled={loading}
        />
        {totalStockLeftType === totalStockLeftTypes.specified && (
          <FormControl.NumberSwitchFormGroup
            value={value}
            onChange={onChange}
            showCounter={true}
            min={0}
            max={50}
            inlineLabel
            disabled={loading}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/accommodation/TotalStockLeftField.jsx